// Function loadHorizontalGalleryBlock loads the HorizontalGalleryBlock class by dynamically importing the js on demand if needed

export function loadHorizontalGalleryBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-horizontal-gallery-block-chunk" */ '../widgets/horizontalGalleryBlock').then(wg => {

		const { HorizontalGalleryBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="HorizontalGalleryBlock"]');

		if(!$wg) {
			// console.info('HorizontalGalleryBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="HorizontalGalleryBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new HorizontalGalleryBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new HorizontalGalleryBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the HorizontalGalleryBlock widget');

}
